/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plus_Reward_TextInputs */

const en_plus_reward_text = /** @type {(inputs: Plus_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Pass`)
};

const ar_plus_reward_text = /** @type {(inputs: Plus_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بطاقة Plus`)
};

const de_plus_reward_text = /** @type {(inputs: Plus_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus-Pass`)
};

const es_plus_reward_text = /** @type {(inputs: Plus_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pase Plus`)
};

const fr_plus_reward_text = /** @type {(inputs: Plus_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passe Plus`)
};

const it_plus_reward_text = /** @type {(inputs: Plus_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pass Plus`)
};

const ja_plus_reward_text = /** @type {(inputs: Plus_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusパス`)
};

const ko_plus_reward_text = /** @type {(inputs: Plus_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 패스`)
};

const pt_br_plus_reward_text = /** @type {(inputs: Plus_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passaporte Plus`)
};

const ru_plus_reward_text = /** @type {(inputs: Plus_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus-пропуск`)
};

const th_plus_reward_text = /** @type {(inputs: Plus_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บัตรผ่าน Plus`)
};

const tr_plus_reward_text = /** @type {(inputs: Plus_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Bilet`)
};

const zh_cn_plus_reward_text = /** @type {(inputs: Plus_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 通行证`)
};

const zh_tw_plus_reward_text = /** @type {(inputs: Plus_Reward_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 通行證`)
};

/**
* | output |
* | --- |
* | "Plus Pass" |
*
* @param {Plus_Reward_TextInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const plus_reward_text = /** @type {((inputs?: Plus_Reward_TextInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plus_Reward_TextInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plus_reward_text(inputs)
	if (locale === "ar") return ar_plus_reward_text(inputs)
	if (locale === "de") return de_plus_reward_text(inputs)
	if (locale === "es") return es_plus_reward_text(inputs)
	if (locale === "fr") return fr_plus_reward_text(inputs)
	if (locale === "it") return it_plus_reward_text(inputs)
	if (locale === "ja") return ja_plus_reward_text(inputs)
	if (locale === "ko") return ko_plus_reward_text(inputs)
	if (locale === "pt_br") return pt_br_plus_reward_text(inputs)
	if (locale === "ru") return ru_plus_reward_text(inputs)
	if (locale === "th") return th_plus_reward_text(inputs)
	if (locale === "tr") return tr_plus_reward_text(inputs)
	if (locale === "zh_cn") return zh_cn_plus_reward_text(inputs)
	return zh_tw_plus_reward_text(inputs)
});